<div fxLayout="row" fxLayoutAlign="space-between center">
    <h2 class="row">{{ "stress-area.title" | translate }} </h2>
    <div *ngIf="topMenuIcons.length > 0">

        <button mat-raised-button *ngFor="let action of topMenuIcons" [routerLink]="action.routerLink"
            (click)="this[action.clickMethod]()">
            <mat-icon [title]="action.title"> {{ action.icon }} </mat-icon>
        </button>
    </div>
</div>
<form [formGroup]="detailForm">
    <div fxLayout="column">
        <div fxLayout="row wrap" fxLayoutGap="40px">
            <mat-form-field *ngIf="columnsVisible.get('id')" [ngStyle]="{
            'width.ch': detailForm.controls['id'].value ? detailForm.controls['id'].value.length : 10,
            'min-width.px': 200
          }">
                <mat-label> {{ "stress-area.id" | translate }} </mat-label>
                <input matInput [ngStyle]="{
              'width.ch': detailForm.controls['id'].value ? detailForm.controls['id'].value.length : 10,
              'min-width.px': 180
            }" formControlName="id" />
            </mat-form-field>

            <mat-form-field *ngIf="columnsVisible.get('calcStatus')" [ngStyle]="{
          'width.ch': detailForm.controls['calcStatus'].value ? detailForm.controls['calcStatus'].value.length : 10,
          'min-width.px': 200
        }">
                <mat-label>{{ "stress-area.calc-status" | translate }}</mat-label>
                <input matInput class="form-control" [ngStyle]="{
            'width.ch': detailForm.controls['calcStatus'].value ? detailForm.controls['calcStatus'].value.length : 10,
            'min-width.px': 180
          }" formControlName="calcStatus" />

            </mat-form-field>

            <mat-form-field *ngIf="columnsVisible.get('calcStatusTrans')" [ngStyle]="{
              'width.ch': detailForm.controls['calcStatusTrans'].value ? detailForm.controls['calcStatusTrans'].value.length : 10,
              'min-width.px': 200
            }">
                    <mat-label>{{ "stress-area.calc-status-trans" | translate }}</mat-label>
                    <input matInput class="form-control" [ngStyle]="{
                'width.ch': detailForm.controls['calcStatusTrans'].value ? detailForm.controls['calcStatusTrans'].value.length : 10,
                'min-width.px': 180
              }" formControlName="calcStatusTrans" />

                </mat-form-field>

            <mat-form-field *ngIf="columnsVisible.get('area')" [ngStyle]="{
              'width.ch': detailForm.controls['area'].value ? detailForm.controls['area'].value.length : 10,
              'min-width.px': 200
            }">
                    <mat-label>{{ "stress-area.area" | translate }}</mat-label>
                    <input matInput type="number" class="form-control" [ngStyle]="{
                'width.ch': detailForm.controls['area'].value ? detailForm.controls['area'].value.length : 10,
                'min-width.px': 180
              }" formControlName="area" />

                </mat-form-field>

            <mat-form-field *ngIf="columnsVisible.get('created')" [ngStyle]="{
            'width.ch': detailForm.controls['created'].value ? detailForm.controls['created'].value.length : 10,
            'min-width.px': 200
         }">
                <mat-label>{{ "stress-area.creation-date" | translate }}</mat-label>
                <input matInput [disabled]='true' value="{{ stressArea.created | date:'yyyy-MM-dd HH:mm' }}"
                    class="form-control" [ngStyle]="{
             'width.ch': detailForm.controls['created'].value ? detailForm.controls['created'].value.length : 10,
             'min-width.px': 180
         }" />

            </mat-form-field>


            <mat-form-field *ngIf="columnsVisible.get('lastModificationDate')" [ngStyle]="{
            'width.ch': detailForm.controls['lastModificationDate'].value ? detailForm.controls['lastModificationDate'].value.length : 10,
            'min-width.px': 200
         }">
                <mat-label>{{ "stress-area.modification-date" | translate }}</mat-label>
                <input matInput [disabled]='true' value="{{ stressArea.lastModificationDate| date:'yyyy-MM-dd HH:mm' }}"
                    class="form-control" [ngStyle]="{
             'width.ch': detailForm.controls['lastModificationDate'].value ? detailForm.controls['lastModificationDate'].value.length : 10,
             'min-width.px': 180
         }" />

            </mat-form-field>
        </div>

        <div fxLayout="row wrap" fxLayoutGap="40px">
            <mat-form-field *ngIf="columnsVisible.get('chainage')" [ngStyle]="{
      'width.ch': detailForm.controls['chainage'].value ? detailForm.controls['chainage'].value.length : 10,
      'min-width.px': 200
    }">
                <mat-label>{{ "stress-area.chainage" | translate }}</mat-label>
                <input matInput type="number" class="form-control" [ngStyle]="{
        'width.ch': detailForm.controls['chainage'].value ? detailForm.controls['chainage'].value.length : 10,
        'min-width.px': 180
      }" formControlName="chainage" />

            </mat-form-field>

            <mat-form-field *ngIf="columnsVisible.get('deformationReal')" [ngStyle]="{
              'width.ch': detailForm.controls['deformationReal'].value ? detailForm.controls['deformationReal'].value.length : 10,
              'min-width.px': 200
            }">
                        <mat-label>{{ "stress-area.deformation_real" | translate }}</mat-label>
                        <input matInput type="number" class="form-control" [ngStyle]="{
                'width.ch': detailForm.controls['deformationReal'].value ? detailForm.controls['deformationReal'].value.length : 10,
                'min-width.px': 180
              }" formControlName="deformationReal" />

                    </mat-form-field>

            <mat-form-field *ngIf="columnsVisible.get('depthSoil')" [ngStyle]="{
              'width.ch': detailForm.controls['depthSoil'].value ? detailForm.controls['depthSoil'].value.length : 10,
              'min-width.px': 200
            }">
              <mat-label>{{ "stress-area.depth-soil" | translate }}</mat-label>
              <input matInput type="number" class="form-control" [ngStyle]="{
                'width.ch': detailForm.controls['depthSoil'].value ? detailForm.controls['depthSoil'].value.length : 10,
                'min-width.px': 180
              }" formControlName="depthSoil" />

          </mat-form-field>

            <mat-form-field *ngIf="columnsVisible.get('depthDisturbance')" [ngStyle]="{
                'width.ch': detailForm.controls['depthDisturbance'].value ? detailForm.controls['depthDisturbance'].value.length : 10,
                'min-width.px': 200
              }">
                <mat-label>{{ "stress-area.depth-disturbance" | translate }}</mat-label>
                <input matInput type="number" class="form-control" [ngStyle]="{
                  'width.ch': detailForm.controls['depthDisturbance'].value ? detailForm.controls['depthDisturbance'].value.length : 10,
                  'min-width.px': 180
                }" formControlName="depthDisturbance" />

            </mat-form-field>


            <mat-form-field *ngIf="columnsVisible.get('depthGravel')" [ngStyle]="{
                'width.ch': detailForm.controls['depthGravel'].value ? detailForm.controls['depthGravel'].value.length : 10,
                'min-width.px': 200
              }">
                <mat-label>{{ "stress-area.depth-gravel" | translate }}</mat-label>
                <input matInput type="number" class="form-control" [ngStyle]="{
                  'width.ch': detailForm.controls['depthGravel'].value ? detailForm.controls['depthGravel'].value.length : 10,
                  'min-width.px': 180
                }" formControlName="depthGravel" />

            </mat-form-field>

            <mat-form-field *ngIf="columnsVisible.get('gravelSpacing')" [ngStyle]="{
              'width.ch': detailForm.controls['gravelSpacing'].value ? detailForm.controls['gravelSpacing'].value.length : 10,
              'min-width.px': 200
            }">
              <mat-label>{{ "stress-area.gravel-spacing" | translate }}</mat-label>
              <input matInput type="number" class="form-control" [ngStyle]="{
                'width.ch': detailForm.controls['gravelSpacing'].value ? detailForm.controls['gravelSpacing'].value.length : 10,
                'min-width.px': 180
              }" formControlName="gravelSpacing" />

          </mat-form-field>

            <mat-form-field *ngIf="columnsVisible.get('depthTunnelPlan')" [ngStyle]="{
                        'width.ch': detailForm.controls['depthTunnelPlan'].value ? detailForm.controls['depthTunnelPlan'].value.length : 10,
                        'min-width.px': 200
                      }">
                <mat-label>{{ "stress-area.depth-tunnelplan" | translate }}</mat-label>
                <input matInput type="number" class="form-control" [ngStyle]="{
                          'width.ch': detailForm.controls['depthTunnelPlan'].value ? detailForm.controls['depthTunnelPlan'].value.length : 10,
                          'min-width.px': 180
                        }" formControlName="depthTunnelPlan" />

            </mat-form-field>

            <mat-form-field *ngIf="columnsVisible.get('depthTunnelConstr')" [ngStyle]="{
              'width.ch': detailForm.controls['depthTunnelConstr'].value ? detailForm.controls['depthTunnelConstr'].value.length : 10,
              'min-width.px': 200
            }">
      <mat-label>{{ "stress-area.depth-tunnel-constr" | translate }}</mat-label>
      <input matInput type="number" class="form-control" [ngStyle]="{
                'width.ch': detailForm.controls['depthTunnelConstr'].value ? detailForm.controls['depthTunnelConstr'].value.length : 10,
                'min-width.px': 180
              }" formControlName="depthTunnelConstr" />

  </mat-form-field>

            <mat-form-field
            *ngIf="columnsVisible.get('kDistSoil')"
            [ngStyle]="{
              'width.ch': detailForm.controls['kDistSoil'].value ? detailForm.controls['kDistSoil'].value.length : 10,
              'min-width.px': 200
            }"
          >
            <mat-label>{{ "stress-area.kDist-soil" | translate }}</mat-label>
            <input
              matInput
              type="number"
              class="form-control" [step]="countDecimalPlaces(detailForm.controls['kDistSoil'].value)"
              [ngStyle]="{
                'width.ch': detailForm.controls['kDistSoil'].value ? detailForm.controls['kDistSoil'].value.length : 10,
                'min-width.px': 180
              }"
              formControlName="kDistSoil"
            />
            <mat-error *ngIf="detailForm.controls['kDistSoil'].errors?.['required']">
              {{ "error.required" | translate }}
            </mat-error>
            <mat-error *ngIf="detailForm.controls['kDistSoil'].errors?.['pattern']">{{ "error.number_pattern" |
              translate }}</mat-error>
          </mat-form-field>

          <mat-form-field
            *ngIf="columnsVisible.get('kSubSoil')"
            [ngStyle]="{
              'width.ch': detailForm.controls['kSubSoil'].value ? detailForm.controls['kSubSoil'].value.length : 10,
              'min-width.px': 200
            }"
          >
            <mat-label>{{ "stress-area.kSub-soil" | translate }}</mat-label>
            <input
              matInput
              type="number"
              class="form-control"
              [ngStyle]="{
                'width.ch': detailForm.controls['kSubSoil'].value ? detailForm.controls['kSubSoil'].value.length : 10,
                'min-width.px': 180
              }"
              formControlName="kSubSoil" [step]="countDecimalPlaces(detailForm.controls['kSubSoil'].value)"
            />
            <mat-error *ngIf="detailForm.controls['kSubSoil'].errors?.['required']">
              {{ "error.required" | translate }}
            </mat-error>
            <mat-error *ngIf="detailForm.controls['kSubSoil'].errors?.['pattern']">{{ "error.number_pattern" |
              translate }}</mat-error>
          </mat-form-field>

            <mat-form-field *ngIf="columnsVisible.get('longitudinal')" [ngStyle]="{
                        'width.ch': detailForm.controls['longitudinal'].value ? detailForm.controls['longitudinal'].value.length : 10,
                        'min-width.px': 200
                      }">
                <mat-label>{{ "stress-area.longitudinal" | translate }}</mat-label>
                <input matInput type="number" class="form-control" [ngStyle]="{
                          'width.ch': detailForm.controls['longitudinal'].value ? detailForm.controls['longitudinal'].value.length : 10,
                          'min-width.px': 180
                        }" formControlName="longitudinal" />

            </mat-form-field>

            <mat-form-field *ngIf="columnsVisible.get('transversal')" [ngStyle]="{
                                'width.ch': detailForm.controls['transversal'].value ? detailForm.controls['transversal'].value.length : 10,
                                'min-width.px': 200
                              }">
                <mat-label>{{ "stress-area.transversal" | translate }}</mat-label>
                <input matInput type="number" class="form-control" [ngStyle]="{
                                  'width.ch': detailForm.controls['transversal'].value ? detailForm.controls['transversal'].value.length : 10,
                                  'min-width.px': 180
                                }" formControlName="transversal" />

            </mat-form-field>

            <mat-form-field *ngIf="columnsVisible.get('springConstant')" [ngStyle]="{
                          'width.ch': detailForm.controls['springConstant'].value ? detailForm.controls['springConstant'].value.length : 10,
                          'min-width.px': 200
                        }">
              <mat-label>{{ "stress-area.spring-constant" | translate }}</mat-label>
              <input matInput type="number" class="form-control" [ngStyle]="{
                            'width.ch': detailForm.controls['springConstant'].value ? detailForm.controls['springConstant'].value.length : 10,
                            'min-width.px': 180
                          }" formControlName="springConstant" />

            </mat-form-field>

            <mat-form-field *ngIf="columnsVisible.get('length')" [ngStyle]="{
                          'width.ch': detailForm.controls['length'].value ? detailForm.controls['length'].value.length : 10,
                          'min-width.px': 200
                        }">
              <mat-label>{{ "stress-area.length" | translate }}</mat-label>
              <input matInput type="number" class="form-control" [ngStyle]="{
                            'width.ch': detailForm.controls['length'].value ? detailForm.controls['length'].value.length : 10,
                            'min-width.px': 180
                          }" formControlName="length" />

            </mat-form-field>

            <mat-form-field *ngIf="columnsVisible.get('width')" [ngStyle]="{
                          'width.ch': detailForm.controls['width'].value ? detailForm.controls['width'].value.length : 10,
                          'min-width.px': 200
                        }">
              <mat-label>{{ "stress-area.width" | translate }}</mat-label>
              <input matInput type="number" class="form-control" [ngStyle]="{
                            'width.ch': detailForm.controls['width'].value ? detailForm.controls['width'].value.length : 10,
                            'min-width.px': 180
                          }" formControlName="width" />

            </mat-form-field>

            <mat-form-field *ngIf="columnsVisible.get('stressPatternAvg')" [ngStyle]="{
                          'width.ch': detailForm.controls['stressPatternAvg'].value ? detailForm.controls['stressPatternAvg'].value.length : 10,
                          'min-width.px': 200
                        }">
              <mat-label>{{ "stress-area.stressPattern-avg" | translate }}</mat-label>
              <input matInput type="number" class="form-control" [ngStyle]="{
                            'width.ch': detailForm.controls['stressPatternAvg'].value ? detailForm.controls['stressPatternAvg'].value.length : 10,
                            'min-width.px': 180
                          }" formControlName="stressPatternAvg" />

            </mat-form-field>

            <mat-form-field *ngIf="columnsVisible.get('stressPatternLong')" [ngStyle]="{
                          'width.ch': detailForm.controls['stressPatternLong'].value ? detailForm.controls['stressPatternLong'].value.length : 10,
                          'min-width.px': 200
                        }">
              <mat-label>{{ "stress-area.stressPattern-long" | translate }}</mat-label>
              <input matInput type="number" class="form-control" [ngStyle]="{
                            'width.ch': detailForm.controls['stressPatternLong'].value ? detailForm.controls['stressPatternLong'].value.length : 10,
                            'min-width.px': 180
                          }" formControlName="stressPatternLong" />
            </mat-form-field>

            <mat-form-field *ngIf="columnsVisible.get('stressPatternTrans')" [ngStyle]="{
                          'width.ch': detailForm.controls['stressPatternTrans'].value ? detailForm.controls['stressPatternTrans'].value.length : 10,
                          'min-width.px': 200
                        }">
              <mat-label>{{ "stress-area.stressPattern-trans" | translate }}</mat-label>
              <input matInput type="number" class="form-control" [ngStyle]="{
                            'width.ch': detailForm.controls['stressPatternTrans'].value ? detailForm.controls['stressPatternTrans'].value.length : 10,
                            'min-width.px': 180
                          }" formControlName="stressPatternTrans" />
            </mat-form-field>

            <mat-form-field *ngIf="columnsVisible.get('gravelAvgAreaPerct')" [ngStyle]="{
                          'width.ch': detailForm.controls['gravelAvgAreaPerct'].value ? detailForm.controls['gravelAvgAreaPerct'].value.length : 10,
                          'min-width.px': 200
                        }">
              <mat-label class="word-wrap">{{ "stress-area.gravel-avg-area-perct" | translate }}</mat-label>
              <input matInput type="number" class="form-control" [ngStyle]="{
                            'margin-top': '0.9em',
                            'width.ch': detailForm.controls['gravelAvgAreaPerct'].value ? detailForm.controls['gravelAvgAreaPerct'].value.length : 10,
                            'min-width.px': 180
                          }" formControlName="gravelAvgAreaPerct" />
            </mat-form-field>

            <mat-form-field *ngIf="columnsVisible.get('gravelCalcAreaPerct')" [ngStyle]="{
              'width.ch': detailForm.controls['gravelCalcAreaPerct'].value ? detailForm.controls['gravelCalcAreaPerct'].value.length : 10,
              'min-width.px': 200
            }">
              <mat-label class="word-wrap">{{ "stress-area.gravel-calc-area-perct" | translate }}</mat-label>
              <input matInput type="number" class="form-control" [ngStyle]="{
                'margin-top': '0.9em',
                'width.ch': detailForm.controls['gravelCalcAreaPerct'].value ? detailForm.controls['gravelCalcAreaPerct'].value.length : 10,
                'min-width.px': 180
              }" formControlName="gravelCalcAreaPerct" />
            </mat-form-field>

            <mat-form-field *ngIf="columnsVisible.get('gravelMeasAreaPerct')" [ngStyle]="{
              'width.ch': detailForm.controls['gravelMeasAreaPerct'].value ? detailForm.controls['gravelMeasAreaPerct'].value.length : 10,
              'min-width.px': 200
            }">
              <mat-label class="word-wrap">{{ "stress-area.gravel-meas-area-perct" | translate }}</mat-label>
              <input matInput type="number" class="form-control" [ngStyle]="{
                'margin-top': '0.9em',
                'width.ch': detailForm.controls['gravelMeasAreaPerct'].value ? detailForm.controls['gravelMeasAreaPerct'].value.length : 10,
                'min-width.px': 180
              }" formControlName="gravelMeasAreaPerct" />
            </mat-form-field>

            <mat-form-field *ngIf="columnsVisible.get('springConstantWithoutGravelArea')" [ngStyle]="{
              'width.ch': detailForm.controls['springConstantWithoutGravelArea'].value ? detailForm.controls['springConstantWithoutGravelArea'].value.length : 10,
              'min-width.px': 200
            }">
              <mat-label  class="word-wrap">{{ "stress-area.spring-constant-without-gravel-area" | translate }}</mat-label>
              <input matInput type="number" class="form-control" [ngStyle]="{
                'margin-top': '0.9em',
                'width.ch': detailForm.controls['springConstantWithoutGravelArea'].value ? detailForm.controls['springConstantWithoutGravelArea'].value.length : 10,
                'min-width.px': 180
              }" formControlName="springConstantWithoutGravelArea" />
            </mat-form-field>

            <mat-form-field *ngIf="columnsVisible.get('reactionRotationReal')" [ngStyle]="{
              'width.ch': detailForm.controls['reactionRotationReal'].value ? detailForm.controls['reactionRotationReal'].value.length : 10,
              'min-width.px': 200
            }">
              <mat-label class="word-wrap">{{ "stress-area.reaction-rotation-real" | translate }}</mat-label>
              <input matInput type="number" class="form-control" [ngStyle]="{
                'margin-top': '0.9em',
                'width.ch': detailForm.controls['reactionRotationReal'].value ? detailForm.controls['reactionRotationReal'].value.length : 10,
                'min-width.px': 180
              }" formControlName="reactionRotationReal" />
            </mat-form-field>

            <mat-form-field *ngIf="columnsVisible.get('reactionUniformReal')" [ngStyle]="{
              'width.ch': detailForm.controls['reactionUniformReal'].value ? detailForm.controls['reactionUniformReal'].value.length : 10,
              'min-width.px': 200
            }">
              <mat-label>{{ "stress-area.reaction-uniform-real" | translate }}</mat-label>
              <input matInput type="number" class="form-control" [ngStyle]="{
                'width.ch': detailForm.controls['reactionUniformReal'].value ? detailForm.controls['reactionUniformReal'].value.length : 10,
                'min-width.px': 180
              }" formControlName="reactionUniformReal" />
            </mat-form-field>

            <mat-form-field *ngIf="columnsVisible.get('rotMomentReal')" [ngStyle]="{
              'width.ch': detailForm.controls['rotMomentReal'].value ? detailForm.controls['rotMomentReal'].value.length : 10,
              'min-width.px': 200
            }">
              <mat-label>{{ "stress-area.rot-moment-real" | translate }}</mat-label>
              <input matInput type="number" class="form-control" [ngStyle]="{
                'width.ch': detailForm.controls['rotMomentReal'].value ? detailForm.controls['rotMomentReal'].value.length : 10,
                'min-width.px': 180
              }" formControlName="rotMomentReal" />
            </mat-form-field>

            <mat-form-field *ngIf="columnsVisible.get('settlement')" [ngStyle]="{
              'width.ch': detailForm.controls['settlement'].value ? detailForm.controls['settlement'].value.length : 10,
              'min-width.px': 200
            }">
              <mat-label>{{ "stress-area.settlement" | translate }}</mat-label>
              <input matInput type="number" class="form-control" [ngStyle]="{
                'width.ch': detailForm.controls['settlement'].value ? detailForm.controls['settlement'].value.length : 10,
                'min-width.px': 180
              }" formControlName="settlement" />
            </mat-form-field>

            <mat-form-field *ngIf="columnsVisible.get('settlementBelowGravelReal')" [ngStyle]="{
              'width.ch': detailForm.controls['settlementBelowGravelReal'].value ? detailForm.controls['settlementBelowGravelReal'].value.length : 10,
              'min-width.px': 200
            }">
              <mat-label>{{ "stress-area.settlement-below-gravel-real" | translate }}</mat-label>
              <input matInput type="number" class="form-control" [ngStyle]="{
                'width.ch': detailForm.controls['settlementBelowGravelReal'].value ? detailForm.controls['settlementBelowGravelReal'].value.length : 10,
                'min-width.px': 180
              }" formControlName="settlementBelowGravelReal" />
            </mat-form-field>

            <mat-form-field *ngIf="columnsVisible.get('verticalLoad')" [ngStyle]="{
              'width.ch': detailForm.controls['verticalLoad'].value ? detailForm.controls['verticalLoad'].value.length : 10,
              'min-width.px': 200
            }">
              <mat-label>{{ "stress-area.vertical-load" | translate }}</mat-label>
              <input matInput type="number" class="form-control" [ngStyle]="{
                'width.ch': detailForm.controls['verticalLoad'].value ? detailForm.controls['verticalLoad'].value.length : 10,
                'min-width.px': 180
              }" formControlName="verticalLoad" />
            </mat-form-field>

            <mat-form-field *ngIf="columnsVisible.get('tunnelSection')" [ngStyle]="{
                                'width.ch':  10,
                                'min-width.px': 200
                              }">
                <mat-label>{{ "stress-area.tunnel-section" | translate }}</mat-label>
                <input matInput class="form-control" [ngStyle]="{
                                  'width.ch': 10,
                                  'min-width.px': 180}"
                    value="{{ stressArea && stressArea.tunnelSection ? stressArea.tunnelSection.name : '' }}"
                    [disabled]="true"
                    />

                  </mat-form-field>

                  <mat-form-field [ngStyle]="{ 'width.ch':  10, 'min-width.px': 200 }">
                    <mat-label>{{ "stress-area.maxErrorPerc" | translate }}</mat-label>
                    <input matInput type="number" class="form-control" [ngStyle]="{
                      'width.ch': 10,
                      'min-width.px': 100
                    }" [value]="getMaxPerc()" disabled />
                  </mat-form-field>

                  <mat-form-field *ngIf="columnsVisible.get('transErrorLine')" [ngStyle]="{
                    'width.ch': detailForm.controls['transErrorLine'].value ? detailForm.controls['transErrorLine'].value.length : 10,
                    'min-width.px': 200
                  }">
                  <mat-label>{{ "stress-area.transErrorLine" | translate }}</mat-label>
                  <input matInput type="number" class="form-control" [ngStyle]="{
                                'width.ch': detailForm.controls['transErrorLine'].value ? detailForm.controls['transErrorLine'].value.length : 10,
                                'min-width.px': 180
                              }" formControlName="transErrorLine" />
                </mat-form-field>
                <mat-form-field *ngIf="columnsVisible.get('longHardEdgeErrorPerc')" [ngStyle]="{
                  'width.ch': detailForm.controls['longHardEdgeErrorPerc'].value ? detailForm.controls['longHardEdgeErrorPerc'].value.length : 10,
                  'min-width.px': 200
                }">
                <mat-label>{{ "stress-area.longHardEdgeErrorPerc" | translate }}</mat-label>
                <input matInput type="number" class="form-control" [ngStyle]="{
                              'width.ch': detailForm.controls['longHardEdgeErrorPerc'].value ? detailForm.controls['longHardEdgeErrorPerc'].value.length : 10,
                              'min-width.px': 180
                            }" formControlName="longHardEdgeErrorPerc" />
              </mat-form-field>
              <mat-form-field *ngIf="columnsVisible.get('longHardCenterErrorPerc')" [ngStyle]="{
                'width.ch': detailForm.controls['longHardCenterErrorPerc'].value ? detailForm.controls['longHardCenterErrorPerc'].value.length : 10,
                'min-width.px': 200
              }">
              <mat-label>{{ "stress-area.longHardCenterErrorPerc" | translate }}</mat-label>
              <input matInput type="number" class="form-control" [ngStyle]="{
                            'width.ch': detailForm.controls['longHardCenterErrorPerc'].value ? detailForm.controls['longHardCenterErrorPerc'].value.length : 10,
                            'min-width.px': 180
                          }" formControlName="longHardCenterErrorPerc" />
            </mat-form-field>
            <mat-form-field *ngIf="columnsVisible.get('longOverallErrorPerc')" [ngStyle]="{
              'width.ch': detailForm.controls['longOverallErrorPerc'].value ? detailForm.controls['longOverallErrorPerc'].value.length : 10,
              'min-width.px': 200
            }">
            <mat-label>{{ "stress-area.longOverallErrorPerc" | translate }}</mat-label>
            <input matInput type="number" class="form-control" [ngStyle]="{
                          'width.ch': detailForm.controls['longOverallErrorPerc'].value ? detailForm.controls['longOverallErrorPerc'].value.length : 10,
                          'min-width.px': 180
                        }" formControlName="longOverallErrorPerc" />
          </mat-form-field>
          <mat-form-field *ngIf="columnsVisible.get('longTwistErrorPerc')" [ngStyle]="{
            'width.ch': detailForm.controls['longTwistErrorPerc'].value ? detailForm.controls['longTwistErrorPerc'].value.length : 10,
            'min-width.px': 200
          }">
          <mat-label>{{ "stress-area.longTwistErrorPerc" | translate }}</mat-label>
          <input matInput type="number" class="form-control" [ngStyle]="{
                        'width.ch': detailForm.controls['longTwistErrorPerc'].value ? detailForm.controls['longTwistErrorPerc'].value.length : 10,
                        'min-width.px': 180
                      }" formControlName="longTwistErrorPerc" />
        </mat-form-field>

        <mat-form-field *ngIf="columnsVisible.get('comment')" [ngStyle]="{
          'width.ch':  10,
          'min-width.px': 700
        }">
        <mat-label>{{ "stress-area.comment" | translate }}</mat-label>
        <input matInput class="form-control" [ngStyle]="{
                    'width.ch': detailForm.controls['comment'].value ? detailForm.controls['comment'].value.length : 10,
                    'min-width.px': 680
                  }" formControlName="comment"
          />
        </mat-form-field>
        </div>
        </div>

</form>